// extracted by mini-css-extract-plugin
export var button = "_1z-1";
export var featuredLink = "_1z-4";
export var spinner = "_1z-2";
export var spinnerContainer = "_1z-3";
export var text = "_1z-0";